import api from "api";
import { useQuery } from "react-query";
import { useId } from "utils/hooks";
import { queryKeys } from "utils/misc";

const useTreatmentHistory = () => {
  const id = useId();
  const key = queryKeys.treatmentHistory(id);

  return useQuery(key, () => api.parse("GET /patients/{id}/treatment_history", [id]));
};

export default useTreatmentHistory;
